export enum ServicePlanRoles {
  VIEWER = 'roles.servicePlanViewer',
  PERSISTER = 'roles.servicePlanPersister',
  INVITER = 'roles.servicePlanInviter',
  PERIOD_MANAGER = 'roles.servicePlanPeriodManager',
  DISCOUNT_MANAGER = 'roles.servicePlanDiscountManager',
}
